// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDiLGlQ1-EocgBS5Q6bF45KU64NK4Ig4NI",
  authDomain: "allaiapplications.firebaseapp.com",
  projectId: "allaiapplications",
  storageBucket: "allaiapplications.firebasestorage.app",
  messagingSenderId: "973086725183",
  appId: "1:973086725183:web:37efc3302503aeffad948a"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

export default auth;
